import { appConfig } from "src/config/default";

export const AUTH_TELEGRAM_BOT_LOGIN = appConfig.telegramBotUsername;

export const LEGAL_DOCUMENTS = appConfig.legalDocuments;
